import {
  SET_MANDATES_LIST,
  SET_SINGLE_MANDATE,
  SET_MANDATES_LOADING,
  SET_MANDATE_METRICS,
} from './actions'

const initialState = {
  mandatesList: [],
  singleMandate: null,
  loading: false,
  metrics: null,
}

const mandatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MANDATES_LIST:
      return {
        ...state,
        mandatesList: action.payload,
      }
    case SET_SINGLE_MANDATE:
      return {
        ...state,
        singleMandate: action.payload,
      }
    case SET_MANDATES_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    case SET_MANDATE_METRICS:
      return {
        ...state,
        metrics: action.payload,
      }
    default:
      return state
  }
}

export default mandatesReducer
